import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'

export default function TrueOrFalse ({context, section, question, questionIndex}) {

  const {translate, quizAssessmentToTake: assessment, assessment: assessmentId} = context

  const answer = assessment.answers[question.id]

  async function handleChange (e) {
    const value = e.target.value == "true"
    const {quizAssessmentToTake: {answers}} = await context.updateState({quizAssessmentToTake: {answers: {[question.id]: {value: {$set: value}, completed: {$set: true}}}}})
    context.saveAnswers({id: assessmentId, answers})
  }

  return (
    <Box className={clsx("question", "true-or-false")}>
      <Box className={clsx("answer")}>
        <RadioGroup className="content" value={answer.value} onChange={handleChange}>
          <FormControlLabel value={true} control={<Radio />} label={translate('true')} />
          <FormControlLabel value={false} control={<Radio />} label={translate('false')} />
        </RadioGroup>
      </Box>
    </Box>
  )
}

